module.exports = __webpack_public_path__ + "Logo 1.bdeba421.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Logo 1.png
// module id = 1bcg
// module chunks = 0